import { useEffect } from 'react';
import './ScanSuccessOverlay.css';

interface ScanSuccessOverlayProps {
  scannedValue: string;
  onDismiss: () => void;
}

const DISPLAY_DURATION_MS = 1400;

export function ScanSuccessOverlay({ scannedValue, onDismiss }: ScanSuccessOverlayProps) {
  useEffect(() => {
    const timeout = setTimeout(onDismiss, DISPLAY_DURATION_MS);
    return () => clearTimeout(timeout);
  }, [onDismiss]);

  return (
    <div className="scan-success" role="status" aria-live="assertive">
      <div className="scan-success__check">
        <span className="scan-line" aria-hidden="true" />✓
      </div>
      <div className="scan-success__title">Lead Captured</div>
      <div className="scan-success__badge font-mono">{truncateForDisplay(scannedValue)}</div>
    </div>
  );
}

/** Opaque UUID QR values and full scan.company.com URLs can both be long -- truncate for the confirmation UI. */
function truncateForDisplay(value: string): string {
  return value.length > 28 ? `${value.slice(0, 25)}…` : value;
}
